import { ThemeOptions } from "@mui/material";

declare module '@mui/material/styles' {
   // allow configuration using `createTheme`
  interface ThemeOptions {
    cartTheme: {
      menuLinkActive: string;
      primaryColor: string;
      infoMessageColor: string;
      alertWarning: string;
      alertWarningBg: string;
      contentBackgroundColor: string;
      stepperSuccessCheck: string;
      highlightedFilter: string;
      commonGrey: string;
      darkGrey: string;
    };
  }
}

export const appTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#007a94',
    },
    error: {
      main: '#E7931F',
    },
  },
  typography: {
    fontFamily: [
      'DaimlerCS-Regular',
      'DaimlerCS-Demi',
    ].join(','),
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          backgroundColor: 'white',
          '&$shrink': {
            fontSize: '14px',
            padding: '0 4px',
            transform: 'translate(10px, -6px)',
          },
        },
      },
    }
  },

  cartTheme: {
    menuLinkActive: '#e0eff2',
    primaryColor: '#007a94',
    infoMessageColor: '#9E9E9E',
    alertWarning: '#e7931f',
    alertWarningBg: '#fae6d2',
    contentBackgroundColor: '#f5f5f5',
    stepperSuccessCheck: '#6fa245',
    highlightedFilter: '#e0f0f1',
    commonGrey: '#e1e1e1',
    darkGrey: '#636363'
  },
};

export const AccordionTheme = {
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  expanded: {},
};
export type { ThemeOptions };

